<template>
  <v-row>
    <v-col cols="12">
      <v-card flat>
        <v-card-text>
          <v-row class="mx-3" no-gutters>
            <v-col cols="12" class="mb-6">
              <v-chip
                v-for="(type, indx) in Object.keys(page_content.eventPriority)"
                :key="`${page_content.eventPriority[type]}_${indx}`"
                class="ma-2"
                :class="current_filter == type ? 'selected' : ''"
                dark
                small
                label
                :color="page_content.eventPriority[type]"
                @click="filter_event(type)"
              >
                {{ type }}
              </v-chip>
            </v-col>
            <v-col cols="12">
              <DataTableVT
                :headers="page_content.events_list"
                :items_list="filtered_list"
                sort_by="startTimestamp"
                item_key="startTimestamp"
                :sort_asc="sort_asc"
                no_export="true"
                print="false"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <DialogVT v-if="is_tester" :contained="contained" />
    </v-col>
    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ error_message }}</v-snackbar>
  </v-row>
</template>

<script>
import DataTableVT from "../components/DataTableVT";
import DialogVT from "../components/DialogVT";

export default {
  name: "EventsList",
  props: {
    page_content: Object,
    events_list: Array,
  },
  components: {
    DataTableVT,
    DialogVT,
    // PrimaryFiltersVT
  },
  data: function () {
    return {
      snackbar: false,
      error_message: null,
      sort_asc: false,
      dialog: false,
      event_id: null,
      contained: true,
      current_filter: null,
    };
  },
  created() {},
  mounted() {},
  methods: {
    filter_event: function (type) {
      this.$emit("clear");
      this.current_filter = this.current_filter == type ? null : type;
    },
  },
  computed: {
    is_tester: function () {
      const ROLE_KEY = process.env["VUE_APP_ROLE_KEY"];
      let role = this.$auth.user[ROLE_KEY] && this.$auth.user[ROLE_KEY];
      return role && role.length > 0 && role.indexOf("Tester") != -1 ? true : false;
    },
    filtered_list: function () {
      return this.events_list
        ? this.current_filter
          ? this.events_list.filter((e) => e.type == this.current_filter)
          : this.events_list
        : [];
    },
  },
};
</script>
<style scoped lang="scss">
.container-width {
  width: 794px;
  overflow-x: visible;
  overflow-y: auto;

  ::v-deep a {
    color: #0581c6 !important;
  }
}

.selected {
  -webkit-filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.8));
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.8));
}

.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}

div.width-30 {
  min-width: 30%;
}
</style>
